"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/margin/selectors");
var _APIconButton = _interopRequireDefault(require("../common/APIconButton/APIconButton"));
var _modalActions = require("../../redux/actions/modalActions");
require("./MarginTransferButton.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MarginTransferButton = function MarginTransferButton(_ref) {
  var isEnabled = _ref.isEnabled,
    onClick = _ref.onClick,
    _ref$showIconButtonLa = _ref.showIconButtonLabel,
    showIconButtonLabel = _ref$showIconButtonLa === void 0 ? true : _ref$showIconButtonLa;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var accounts = (0, _reactRedux.useSelector)(_selectors.accountsSelector);
  if (accounts.length === 1) return null;
  return /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
    iconName: "transfer",
    showLabel: showIconButtonLabel,
    tooltipText: t('Transfer'),
    customClass: "transfer-btn",
    action: onClick,
    isDisabled: !isEnabled
  });
};
var mapStateToProps = function mapStateToProps(state) {
  var accounts = (0, _selectors.accountsSelector)(state);
  return {
    isEnabled: accounts.length > 1
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onClick: function onClick() {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.MARGIN_TRANSFER_ASSETS, {
        productId: ownProps.productId
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MarginTransferButton);